import logo from "./logo.svg";
import "./App.css";
import OurMission from "./components/OurMission";
import AboutUs from "./components/AboutUs";
import Footer from "./components/Footer";
import OurStats from "./components/OurStats";
import OurServices from "./components/OurServices";
import Header from "./components/Header";
import OurProcess from "./components/OurProcess";
import OurWorks from "./components/OurWorks";
import Portfolio from "./components/Portfolio";
import ContactForm from "./components/ContactForm";
import Testimonials from "./components/Testimonials";
import OurTeam from "./components/OurTeam";

function App() {
  return (
    <>
      <Header />
      <AboutUs />
      <OurMission />
      {/* <OurTeam /> */}
      <hr />

      {/* <Testimonials /> */}
      <OurProcess />
      <hr />
      {/* <OurWorks /> */}
      {/* <Portfolio /> */}
      <section
        id="action-box2"
        className="action-box action-black"
        style={{ backgroundColor: "rgba(34, 34, 34, 0.85)" }}
      >
        <div className="container">
          <div className="row action-box-left">
            <h4 className="action-box-title">
              Ready to elevate your operations with a smarter ERP system? Let us
              build your next competitive advantage—intelligent, integrated, and
              built just for you!
            </h4>
            <br />
          </div>

          <div className="action-box-right">
            <a className="btn btn-md btn-color" href="#contact-us">
              Contact Us
            </a>
          </div>
        </div>
      </section>
      <OurServices />
      <OurStats />
      <ContactForm />
      <Footer />
    </>
  );
}

export default App;
